import { COOKIE_SETTINGS_REDUCER } from '../constants';
import { useCustomSelector } from './useCustomSelector';

import { TCookieSettingsSelector, TEqualityFunction } from '../types';

export const useCookieSettingsSelector = <TSelected>(
    selector: TCookieSettingsSelector<TSelected>,
    equalityFn?: TEqualityFunction<TSelected>
) => {
    return useCustomSelector<TSelected, typeof COOKIE_SETTINGS_REDUCER>(COOKIE_SETTINGS_REDUCER, selector, equalityFn);
};
